// German for the form modals' drafting chat (the shell's strings live in AgentFlyout.de.ts).
import { registerDe } from '../i18n/index.js';

registerDe({
  'Draft with the agent': 'Mit dem Agenten entwerfen',
  'agent · proposes into the fields, a take fills the form': 'Agent · schlägt in die Felder vor, erst die Übernahme füllt das Formular',
  'Discuss what belongs in the fields. The agent reads the engagement, proposes text per field, and you steer — a proposal lands only when you take it.':
    'Besprechen Sie, was in die Felder gehört. Der Agent liest den Auftrag, schlägt Text pro Feld vor, und Sie steuern — ein Vorschlag landet erst, wenn Sie ihn übernehmen.',
  'Take into {field}': 'In {field} übernehmen',
  'e.g. “Draft a checkable definition of done”': 'z. B. «Entwirf prüfbare Abnahmekriterien»',
  'The agent did not answer.': 'Der Agent hat nicht geantwortet.',
}, 'FieldChat');
